// Module
var code = "<div class=\"paymentMethods_item t-paymentMethods_item -boleto\"> </div> ";
// Exports
export default code;